<template>
  <div class="box">
    <comment :comment="comment" can-reply>
      <div slot="media-right"></div>
    </comment>
  </div>
</template>

<script>
import Comment from "./Comment";

export default {
  components: {
    Comment
  },

  props: ["comment"]
};
</script>
